import WebapiError from './types';

export default class WebError extends WebapiError {
    constructor(title: string, message: string) {
        super({ title, message });
        this.name = 'WebError';
        Object.setPrototypeOf(this, WebError.prototype);
    }
}
